export const STANDARD_DEVIATION_DROP_MULTIPLIER_DOWN_VALUES = [
  0.01,
  0.02,
  0.03,
  0.04,
  0.05,
  0.1,
  0.2,
  0.3,
  0.4,
  0.5,
  0.75,
  0.88,
  1.0,
  1.25,
  1.5,
  1.75,
  2.0,
  2.25,
  2.5,
  2.75,
  3.0
];

export const STANDARD_DEVIATION_MULTIPLIER_DEFAULT = 1.0;

export const STANDARD_DEVIATION_TERM_DROP_DOWN_VALUES = [6, 12, 18, 24, 30, 36, 48, 60];

export const STANDARD_DEVIATION_TERM_DEFAULT = 36;

export const DAMPING_UP_VALUES = [
  ...Array(25)
    .fill(null)
    .map((e, i) => ++i), // [1 .. 25]
  ...[30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 750],
  ...[1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]
];

export const DAMPING_DOWN_VALUES = [
  ...Array(20)
    .fill(null)
    .map((e, i) => ++i), // [1 .. 20]
  ...[25, 30, 40, 50]
];

export const DAMPING_UP_DEFAULT = 100;

export const DAMPING_DOWN_DEFAULT = 20;

export const FORECAST_GROWTH_DEFAULT = 0;
